(() => {
  const root = document.querySelector('[data-mh-root]');
  if (!root) return;

  const variants = [...document.querySelectorAll('[data-mh-variant]')];
  const statuses = [...document.querySelectorAll('[data-mh-status]')];
  const sizeButtons = [...document.querySelectorAll('[data-mh-size-choice]')];
  const modal = document.querySelector('[data-mh-fit-modal]');
  let variantId = root.dataset.variantId;

  const selectVariant = (id) => {
    variantId = String(id);
    root.dataset.variantId = variantId;
    variants.forEach((select) => { select.value = variantId; });
    sizeButtons.forEach((button) => button.classList.toggle('is-selected', button.dataset.mhSizeChoice === variantId));
    statuses.forEach((node) => { node.textContent = ''; });
  };

  variants.forEach((select) => select.addEventListener('change', () => selectVariant(select.value)));
  sizeButtons.forEach((button) => button.addEventListener('click', () => {
    selectVariant(button.dataset.mhSizeChoice);
    if (modal?.open) modal.close();
  }));
  selectVariant(variantId);

  document.querySelectorAll('[data-mh-add]').forEach((button) => button.addEventListener('click', async () => {
    const original = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';
    try {
      const response = window.Rarely?.cart
        ? await window.Rarely.cart({ variantId, quantity: 1 })
        : await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
        }).then((result) => ({ ok: result.ok }));
      if (response?.ok === false) throw new Error('Unable to add');
      if (typeof window.fbq === 'function') window.fbq('track', 'AddToCart', { content_ids: [variantId], content_name: 'Stormy Kromer Mesh Hiker', content_type: 'product', value: 95, currency: 'USD' });
      statuses.forEach((node) => { node.textContent = 'Added to cart.'; });
      button.textContent = 'Added ✓';
    } catch (error) {
      statuses.forEach((node) => { node.textContent = 'Something went wrong. Please try again.'; });
      button.textContent = original;
    } finally {
      window.setTimeout(() => { button.disabled = false; button.textContent = original; }, 1800);
    }
  }));

  const tooltip = document.querySelector('[data-mh-tooltip]');
  const featureCopy = {
    mesh: ['01 · Mesh crown', 'Air in. Heat out.', 'The open crown lets air circulate where a traditional solid hat holds warmth.'],
    brim: ['02 · 2½-inch brim', 'Useful shade, all the way around.', 'The wide twill brim cuts glare from the trail, garden, and water without taking over the hat.'],
    cord: ['03 · Leather chin cord', 'Ready when the wind joins in.', 'Wear it loose in still air and snug it down when a breeze starts testing the brim.']
  };
  document.querySelectorAll('[data-mh-hotspot]').forEach((button) => button.addEventListener('click', () => {
    const [label, title, body] = featureCopy[button.dataset.mhHotspot];
    document.querySelectorAll('[data-mh-hotspot]').forEach((node) => {
      const active = node === button;
      node.classList.toggle('is-active', active);
      node.setAttribute('aria-expanded', String(active));
    });
    tooltip.innerHTML = `<small>${label}</small><h3>${title}</h3><p>${body}</p>`;
  }));

  document.querySelectorAll('[data-mh-fit-open]').forEach((button) => button.addEventListener('click', () => modal?.showModal()));
  document.querySelector('[data-mh-fit-close]')?.addEventListener('click', () => modal.close());
  modal?.addEventListener('click', (event) => { if (event.target === modal) modal.close(); });

  const sticky = document.querySelector('[data-mh-sticky]');
  const hero = document.querySelector('[data-mh-hero]');
  if (sticky && hero && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting), { threshold: 0.08 }).observe(hero);
  }

  if (typeof window.fbq === 'function') window.fbq('track', 'ViewContent', { content_ids: [variantId], content_name: 'Stormy Kromer Mesh Hiker', content_type: 'product', value: 95, currency: 'USD' });

  const scrollToHash = () => {
    if (!window.location.hash) return;
    const target = document.querySelector(window.location.hash);
    if (target) window.requestAnimationFrame(() => target.scrollIntoView({ block: 'start' }));
  };
  window.addEventListener('load', scrollToHash, { once: true });
  window.addEventListener('hashchange', scrollToHash);
})();
